import client from '../ApolloClient'
import gql from 'graphql-tag'
// eslint-disable-next-line
import { Observable, Subject, filter, switchMap, map } from 'rxjs'

import {
  FETCH_SEARCH_TERMS, FETCH_PUSH_NOTIFICATIONS, FETCH_BANNER_CONTENT,
  failFetch, loadSearchTerms, loadPushNotifications, loadBannerContent
} from '../Actions/Other'

import { contentAnalyticsQuery } from './Content'

const searchTermQuery = gql`query allSearchTerms($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int, $appProfileIds: [ID!], $groupIds: [ID!], $appType: AppType!) {
  allSearchTerms(accountId: $accountId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, appProfileIds: $appProfileIds, groupIds: $groupIds, appType: $appType) {
    searchTerms
    count
  }
}`

/**
  * searchTermsEpic
  * @desc action Observer that sends a query and processes result if the action is a dearch terms action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const searchTermEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_SEARCH_TERMS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: searchTermQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadSearchTerms(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

const pushNotificationQuery = gql`query allPushNotifications($accountId: String!,
      $startDate: DateTime!, $endDate: DateTime!, $limit: Int, $offset: Int, $appProfileIds: [ID!], $groupIds: [ID!], $appType: AppType) {
  allPushNotifications (accountId: $accountId, startDate: $startDate, endDate: $endDate, limit: $limit, offset: $offset, appProfileIds: $appProfileIds, groupIds: $groupIds, appType: $appType) {
    pushNotifications {
      notificationType
      message
      view
      opens
    }
    count
  }
}`

/**
  * pushNotificationEpic
  * @desc action Observer that sends a query and processes result if the action is a push notification action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const pushNotificationEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_PUSH_NOTIFICATIONS),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: pushNotificationQuery, variables: action.query })
        .then((data) => { subject.next(data) })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadPushNotifications(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )

/**
  * topBannerEpic
  * @desc action Observer that sends a query and processes result if the action is a fetch banner content action
  * @param {Observable<action>} action$ Action Observable stream
  * @return {action}
*/
export const topBannerEpic = action$ =>
  action$.pipe(
    filter(action => action.type === FETCH_BANNER_CONTENT),
    switchMap(action => {
      const subject = new Subject()
      client.query({ query: contentAnalyticsQuery, variables: { ...action.query, sortField: 'totalViews', sortDirection: 'DESCENDING' } })
        .then((data) => {
          subject.next(data)
        })
        .catch((error) => {
          subject.next(error)
        })
      return subject.pipe(
        map((response) => {
          if (response.data) {
            return loadBannerContent(response.data)
          } else {
            return failFetch(response)
          }
        })
      )
    })
  )
